import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const VipHeader: React.FC = () => {
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  return (
    <header className="vip-header">
      <div className="container nav">
        <Link to="/vip" className="brand">
          <div className="logo"></div>
          <div>
            <div className="brand-title">广东凡思彼得科技有限公司</div>
            <div className="brand-sub">Enterprise Compliance & AI Qualification Consulting</div>
          </div>
        </Link>
        <nav>
          <ul>
            <li><Link to="/vip" className={isActive('/vip') && location.pathname === '/vip' ? 'active' : ''}>首页</Link></li>
            <li><Link to="/vip/services" className={isActive('/vip/services') ? 'active' : ''}>服务中心</Link></li>
            <li><Link to="/vip/ai-solutions" className={isActive('/vip/ai-solutions') ? 'active' : ''}>AI 解决方案</Link></li>
            <li><Link to="/vip/process" className={isActive('/vip/process') ? 'active' : ''}>办理流程</Link></li>
            <li><Link to="/vip/faq" className={isActive('/vip/faq') ? 'active' : ''}>常见问题</Link></li>
            <li><Link to="/vip/about" className={isActive('/vip/about') ? 'active' : ''}>关于我们</Link></li>
            <li><Link to="/vip/contact" className={isActive('/vip/contact') ? 'active' : ''}>联系我们</Link></li>
          </ul>
        </nav>
        <div className="nav-actions">
          <Link className="btn btn-secondary" to="/vip/contact">立即咨询</Link>
          <Link className="btn btn-primary" to="/vip/ai-solutions">获取方案</Link>
        </div>
      </div>
    </header>
  )
}

export default VipHeader
